import Add from './Add/addStoreGroup';
import List from './List/listStoreGroup';
import View from './View/viewStoreGroup';

export default {
  Add: Add,
  View: View,
  List: List
};
